export default __webpack_public_path__ + "static/media/ConveyorMk3.256.41c97f56.png";